import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';

import '../src/assets/fonts/OPTIVenus-BoldExtended.otf';
import '../src/assets/fonts/Montserrat-Medium.ttf';
import '../src/assets/fonts/Montserrat-SemiBold.ttf';

import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));
